import React from 'react';

const CommunityCardSkeleton = () => {
  return (
    <div className="card skeleton-card">
      <div className="card-body-content">
        {/* Avatar Section Skeleton */}
        <div className="card-header-image">
          <div className="skeleton skeleton-avatar"></div>
        </div>

        {/* Title and Description Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-title" style={{ marginBottom: '12px' }}></div>
          <div className="skeleton skeleton-text" style={{ marginBottom: '8px' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '80%' }}></div>
        </div>

        {/* Social Links Section Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-heading" style={{ marginBottom: '8px', width: '40%' }}></div>
          <div className="card-links">
            <div className="skeleton skeleton-badge"></div>
            <div className="skeleton skeleton-badge"></div>
            <div className="skeleton skeleton-badge"></div>
          </div>
        </div>

        {/* Linktree Section Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-heading" style={{ marginBottom: '8px', width: '30%' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '60%' }}></div>
        </div>

        {/* Rating Section Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-stars" style={{ width: '50%' }}></div>
        </div>

        {/* Buttons Section Skeleton */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <div className="skeleton skeleton-button"></div>
          <div className="skeleton skeleton-button"></div>
        </div>
      </div>
    </div>
  );
};

export default CommunityCardSkeleton;
